export const getAreaPath = () => {
    // this value cloud be area name like 'yokohama', but at some cases not.
    const subDirName = window.location.pathname.split("/")[1];
    const AREAS = ["yokohama", "omiya", "osaka"];
    const matched = AREAS.find((a) => a === subDirName);
    return matched ? `/${matched}` : "";
};
